export default __webpack_public_path__ + "static/media/3.ff9bd867.png";